import React, { useState, useCallback } from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import { Button, Chip, Avatar, Box } from '@mui/material';
import { ChapterSelector } from './ChapterSelector';

export const ChapterNode = ({ data, selected, id }) => {
  const { setNodes } = useReactFlow();
  const [isSelectorOpen, setIsSelectorOpen] = useState(false);

  const handleChapterSelect = useCallback((chapter) => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              chapterId: chapter.id,
              chapterName: chapter.name,
              chapterAvatar: chapter.avatar
            }
          };
        }
        return node;
      })
    );
    setIsSelectorOpen(false);
  }, [id, setNodes]);

  const handleChapterRemove = useCallback(() => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              chapterId: null,
              chapterName: null,
              chapterAvatar: null
            }
          };
        }
        return node;
      })
    );
  }, [id, setNodes]);

  return (
    <div className="react-flow__node-default" style={{ minWidth: 180 }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ 
          left: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="condition-label">
        <label style={{ display: 'block' }}>Next Chapter</label>
      </div>

      <div style={{ padding: 20, paddingTop: 0 }}>
        {data.chapterId ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip 
              avatar={<Avatar alt={data.chapterName} src={data.chapterAvatar} />}   
              label={data.chapterName} 
              onDelete={handleChapterRemove}
              color="primary" 
            />
          </Box>
        ) : (
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => setIsSelectorOpen(true)}
          >
            Select chapter
          </Button>
        )}
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="default"
        style={{
          right: 0,
          top: '64%',
          transform: 'translateY(-50%)'
        }}
      />

      <ChapterSelector
        open={isSelectorOpen}
        onClose={() => setIsSelectorOpen(false)}
        onSelect={handleChapterSelect}
      />
    </div>
  );
}; 